import { Observer } from "mobx-react";

import QuestionareStore from "../../stores/QuestionareStore";
import { getMobileOperatingSystem } from "../../constants/utils";
import Styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";

const Footer = () => {
  const isiOS = getMobileOperatingSystem() === "iOS";

  return (
    <Observer>
      {() => {
        const isNextDisabled = QuestionareStore.isNextButtonDisabled();
        const isBackDisabled = QuestionareStore.currentQuestionIndex == 0;

        return (
          <div>
            <input
              type="button"
              value="back"
              className={isiOS ? iStyles.BackBtn : Styles.BackBtn}
              style={{ opacity: isBackDisabled ? 0.5 : 1 }}
              disabled={isBackDisabled}
              onClick={QuestionareStore.handleBackPress}
            />
            <input
              type="button"
              value="next"
              className={isiOS ? iStyles.NextBtn : Styles.NextBtn}
              style={{ opacity: isNextDisabled ? 0.5 : 1 }}
              disabled={isNextDisabled}
              onClick={QuestionareStore.handleNextPress}
            />
          </div>
        );
      }}
    </Observer>
  );
};

export default Footer;
